import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
};

const sellerUiSlice = createSlice({
  name: 'sellerUi',
  initialState,
  reducers: {
    setSidebarShow: (state, action) => {
      state.sidebarShow = action.payload;
    },
    toggleSidebarShow: (state) => {
      state.sidebarShow = !state.sidebarShow;
    },
    toggleSidebarUnfoldable: (state) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable;
    },
  },
});

export const {
  setSidebarShow,
  toggleSidebarShow,
  toggleSidebarUnfoldable,
} = sellerUiSlice.actions;

export default sellerUiSlice.reducer;
